/**
 * Токены темы planr для TS-кода: инлайновых стилей и пропсов вроде `color`.
 *
 * Значения — ссылки на CSS-переменные из `root/styles/planr/tokens.scss`, а не
 * копии hex: источник правды остаётся один, в SCSS. Поэтому годятся только туда,
 * где браузер разбирает CSS. Canvas и amCharts `var(...)` не понимают — им
 * по-прежнему нужен сам цвет.
 */
export const colors = {
    brand: "var(--planr-brand)",
    brandLight: "var(--planr-brand-light)",
    brandDark: "var(--planr-brand-dark)",
    text: "var(--planr-text)",
    textSecondary: "var(--planr-text-secondary)",
    white: "var(--planr-white)",

    success: "var(--planr-success)",
    successLight: "var(--planr-success-light)",
    danger: "var(--planr-danger)",
    dangerLight: "var(--planr-danger-light)",
    info: "var(--planr-info)",
    infoLight: "var(--planr-info-light)",
    purple: "var(--planr-purple)",
    purpleLight: "var(--planr-purple-light)",

    input: "var(--planr-input)",
    disabled: "var(--planr-disabled)",
    border: "var(--planr-border)",
    focus: "var(--planr-focus)",
    surface: "var(--planr-surface)",
} as const;

export type ColorToken = keyof typeof colors;

/** Шкала отступов: 4 / 8 / 12 / 16 / 24 / 32 px. */
export const space = {
    none: "0",
    xs: "var(--planr-space-xs)",
    s: "var(--planr-space-s)",
    m: "var(--planr-space-m)",
    l: "var(--planr-space-l)",
    xl: "var(--planr-space-xl)",
    xxl: "var(--planr-space-xxl)",
} as const;

export type SpaceToken = keyof typeof space;

export const radius = "var(--planr-radius)";
